/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} MondayInputs */

const en_monday = /** @type {(inputs: MondayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monday`)
};

const de_monday = /** @type {(inputs: MondayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montag`)
};

/**
* | output |
* | --- |
* | "Monday" |
*
* @param {MondayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const monday = /** @type {((inputs?: MondayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<MondayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_monday(inputs)
	return de_monday(inputs)
});